import { render, staticRenderFns } from "./BundleBlockComponent.vue?vue&type=template&id=602ce2ac"
import script from "./BundleBlockComponent.vue?vue&type=script&lang=js"
export * from "./BundleBlockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports